import { keyframes } from '@mui/system';

/**
 * Diagonal sheen sweep (DESIGN_SYSTEM.md section 6 motion). A light band crosses
 * the element early in the timeline, then idles for the rest of the cycle, so on
 * a long cycle the glint is rare. Reduced-motion disables it.
 */
const sheenSweep = keyframes`
  0%   { transform: translateX(-160%) rotate(8deg); opacity: 0; }
  2%   { opacity: 1; }
  22%  { opacity: 1; }
  24%  { transform: translateX(160%) rotate(8deg); opacity: 0; }
  100% { transform: translateX(160%) rotate(8deg); opacity: 0; }
`;

/**
 * sx fragment for an infrequent diagonal sheen-sweep overlay. Apply to a square
 * or round element; it positions an ::after band that sweeps across once per
 * theme.ds.motion.shimmerCycle, offset by `delay` so siblings stagger off the
 * same period. The host element gets position:relative + overflow:hidden.
 *
 * @param {object} theme            MUI theme
 * @param {object} [opts]
 * @param {string} [opts.delay]     per-element start offset (e.g. '2600ms')
 * @returns {object} sx fragment
 */
export const sheenSx = (theme, { delay = '0ms' } = {}) => ({
  position: 'relative',
  overflow: 'hidden',
  '&::after': {
    content: '""',
    position: 'absolute',
    inset: 0,
    background:
      'linear-gradient(105deg, transparent 30%, rgba(251, 251, 252, 0.32) 50%, transparent 70%)',
    transform: 'translateX(-160%) rotate(8deg)',
    pointerEvents: 'none',
    animation: `${sheenSweep} ${theme.ds.motion.shimmerCycle} ${theme.ds.motion.easeInOut} ${delay} infinite`,
  },
  '@media (prefers-reduced-motion: reduce)': {
    '&::after': { animation: 'none', opacity: 0 },
  },
});

export default sheenSx;
